import React from 'react';
import { Switch, Route } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import LinearProgress from '@mui/material/LinearProgress';

import SetNewPasswordPage from '@ts-core/modules/auth/pages/SetNewPasswordPage';
import { ApiClientProvider } from '@ts-core/lib/apiClient';
import { CourseProvider } from '@ts-core/context/course';

import TermsAndConditionsPage from 'modules/account/pages/TermsAndConditionsPage';
import PrivacyPolicyPage from 'modules/account/pages/PrivacyPolicyPage';
import LoginPage from './modules/account/pages/LoginPage';
import { useStudentAuth } from 'modules/account/hooks';

import StudentPrivateSection from 'core/pages/StudentPrivateSection';

const Routes = () => {
  return (
    <Switch>
      <Route component={TermsAndConditionsPage} path="/terms" />
      <Route component={PrivacyPolicyPage} path="/privacy-policy" />
      <Route component={LoginPage} path="/login" exact />
      <Route path="/set-new-password" exact component={SetNewPasswordPage} />
      <Route component={StudentPrivateSection} />
    </Switch>
  );
};

const App = () => {
  const { loading, loadingUser } = useStudentAuth();
  return (
    <ApiClientProvider apiBaseUrl="/v2/student/">
      <CourseProvider>
        <CssBaseline />
        {loading || loadingUser ? <LinearProgress /> : <Routes />}
      </CourseProvider>
    </ApiClientProvider>
  );
};

export default App;
